import React from 'react';
import MyModal from '../../templates/MyModal';
import MyButton from '../../templates/MyButton';
import useTranslation from '../../translations';
import styles from './css/index.module.scss';

function InvalidAdditionalRecipientsModal({ isOpen, closeFunction, invalidEmails }) {
  const { t } = useTranslation();

  return (
    <MyModal isOpen={isOpen} closeFunction={closeFunction}>
      <div className={styles.wrapper}>
        <p className={styles.title}>{t('invalid_additional_recipients')}</p>
        <ul className={styles.list}>
          {invalidEmails?.map((email) => (
            <li key={email}>{email}</li>
          ))}
        </ul>
        <MyButton className="modal_save_button" text={t('ok')} onClick={closeFunction} />
      </div>
    </MyModal>
  );
}

export default InvalidAdditionalRecipientsModal;
